module.exports = __webpack_public_path__ + "img/gr.a23683b2.svg";